import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

//Layouts
import { FullLayoutComponent } from './layouts/full-layout.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'register',
    pathMatch: 'full',
  },
  {
    path: '',
    component: FullLayoutComponent,
    data: {
      title: 'Registro'
    },
    children: [
        {
            path: 'register',
            loadChildren: './pages/register/register.module#RegisterPageModule'
        },
        {
          path: 'login',
          loadChildren: './pages/login/login-page.module#LoginPageModule'
        },
        {
          path: 'role-list',
          loadChildren: './pages/role-list/role-list.module#RoleListModule'
        },
        {
          path: 'user-list',
          loadChildren: './pages/user-list/user-list.module#UserListModule'
        }
    ]
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts